import { render, staticRenderFns } from "./CreateCommunityPick.vue?vue&type=template&id=19f0545a&"
import script from "./CreateCommunityPick.vue?vue&type=script&lang=js&"
export * from "./CreateCommunityPick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports